var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.list)?_c('span',[_vm._l((_vm.item),function(listItem,index){return [_c('span',{key:index},[_vm._v(_vm._s(_vm.getListItemFormated(listItem, index)))]),_c('br',{key:(index + "-br")})]})],2):_c('span',[_vm._v(_vm._s(_vm.getItemTitle))])}
var staticRenderFns = []

export { render, staticRenderFns }